// extracted by css-extract-rspack-plugin
export default {"children":"children-R8P_S3"};